// extracted by mini-css-extract-plugin
export default {"wrapper":"Qz-z","viewport":"Rz-z","container":"Sz-z","slide":"Tz-z"};